export var VERSION = "1.5.4";
export var APPLICATION_ID = "EK4QDXyjTzcNpo0rdlRpvgez6UHaTuy2V5fhJgQv";
export var JAVASCRIPT_KEY = "TfXo7K35l5Ez3tbZ1gCfcWpdXHcIV4bRYLs2Lioxo";
export var API_URI = process.env.REACT_APP_API 
                      ? process.env.REACT_APP_API 
                      : process.env.NODE_ENV == "production" 
                        ? "https://api.joinoptn.com" 
                        : "http://localhost:1337";